import { render } from "./PageLoader.vue?vue&type=template&id=0e7dc3d1"
import script from "./PageLoader.vue?vue&type=script&lang=js"
export * from "./PageLoader.vue?vue&type=script&lang=js"

import "./PageLoader.vue?vue&type=style&index=0&id=0e7dc3d1&lang=scss"
script.render = render

export default script